module.exports = __webpack_public_path__ + "static/media/p0303.e4208509.png";